const WIDGET_CUSTOMIZATION = {
  // Menu
  WIDGET_TAB_LANDING: 'Landing Page',
  WIDGET_TAB_CUSTOMIZATION: 'Customization',
  WIDGET_TAB_DISPLAY: 'Display',
  WIDGET_TAB_POSITION: 'Position',

  //Landing
  WIDGET_LANDING_LANGUAGE_SELECT_ENGLISH: 'English',
  WIDGET_LANDING_LANGUAGE_SELECT_PERSIAN: 'Persian',
  WIDGET_LANDING_LANGUAGE_TITLE: 'Widget language',
  WIDGET_LANDING_LANGUAGE_DESC: 'Display the widget in the language',
  WIDGET_LANDING_TITLE_TITLE: 'Title',
  WIDGET_LANDING_TITLE_DESC: 'The text is displayed in the dialog widget.',
  WIDGET_LANDING_TITLE_PLACEHOLDER: 'Enter welcome message',
  WIDGET_LANDING_TITLE_FA: 'Farsi (default)',
  WIDGET_LANDING_TITLE_EN: 'English',
  WIDGET_LANDING_LANG_SELECT_TITLE: 'Select language',
  WIDGET_LANDING_TEAM_TITLE: 'Introducing the team',
  WIDGET_LANDING_TEAM_DESC:
    'Introduce your team and tell how you can help the customer.',
  WIDGET_LANDING_TEAM_DESC_PLACEHOLDER: 'Enter introduction text',
  WIDGET_LANDING_CONV_TITLE: 'Start conversation',
  WIDGET_LANDING_CONV_INPUT_TITLE: 'Text',
  WIDGET_LANDING_CONV_INPUT_PLACEHOLDER: 'Enter conversation starter text',
  WIDGET_LANDING_START_MSG_TITLE: 'Description',
  WIDGET_LANDING_START_MSG_DESC: "Enter conversation starter's description",

  // Customization
  WIDGET_LOGO_UPLOAD_TITLE: 'Logo',
  WIDGET_LOGO_UPLOAD_SUBTITLE:
    'The suggested dimensions of the logo should be 60 x 60 pixels and in png format.',
  WIDGET_LOGO_UPLOAD_BTN: 'Upload a custom logo',
  WIDGET_LOGO_UPLOAD_REMOVE: 'Remove Logo',
  WIDGET_LOGO_DEFAULT_TITLE: 'Default Logos',
  WIDGET_LOGO_BG_COLOR: 'Background color',
  WIDGET_LOGO_WIDGET_BG_COLOR_DESC:
    'The color used in the background of headers and landing pages',
  WIDGET_LOGO_BG_COLOR_TITLE: 'Logo background color',
  WIDGET_LOGO_BG_COLOR_DESC:
    'The color used for the background of the widget logo and the landing page logo',

  WIDGET_LOGO_SECONDARY_COLOR_TITLE: 'complementary color',
  WIDGET_HEADER_TITLE_COLOR_TITLE: 'Title color',
  WIDGET_HEADER_TITLE_COLOR_DESC: 'Header and landing title',
  WIDGET_LOGO_SECONDARY_COLOR_DESC:
    'The color used in buttons and important parts',
  WIDGET_LOGO_BG_PATTERN_TITLE: 'Background design',

  // Display
  WIDGET_DISPLAY_TITLE: 'Set widget display',
  WIDGET_DISPLAY_VACATION_SWITCH_LABEL: 'Vacation mode',
  WIDGET_DISPLAY_VACATION_SWITCH_SUBTEXT: '(not displaying widgets)',
  WIDGET_DISPLAY_VACATION_NOTE:
    'Note: It is mandatory to enter the protocol in the page address (http, https).',
  WIDGET_DISPLAY_PAGES_TO_DISPLAY_TITLE: 'Display widgets only on these pages',
  WIDGET_DISPLAY_PAGES_TO_DISPLAY_PLACEHOLDER:
    'Enter page address. example: https://example.com',
  WIDGET_DISPLAY_PAGES_NOT_TO_DISPLAY_TITLE:
    'Not displaying widgets on these pages',
  WIDGET_DISPLAY_PAGES_NOT_TO_DISPLAY_PLACEHOLDER:
    'Enter page address. example: https://example.com',
  WIDGET_DISPLAY_PAGES_LINK_ADD_BTN: 'Add',

  // Position
  WIDGET_POSITION_DIR_TITLE: 'Your website direction',
  WIDGET_POSITION_DIR_SELECT_TITLE: 'Select direction',
  WIDGET_POSITION_TITLE: 'Widget position',
  WIDGET_POSITION_SELECT_TITLE: 'Select widget position',
  WIDGET_POSITION_PIXEL: 'Pixels',
  WIDGET_POSITION_MOBILE_LABEL: 'Widget display on mobile',
  WIDGET_POSITION_TOP_LEFT: 'Top Left',
  WIDGET_POSITION_TOP_RIGHT: 'Top Right',
  WIDGET_POSITION_BOTTOM_LEFT: 'Bottom Left',
  WIDGET_POSITION_BOTTOM_RIGHT: 'Bottom Right',
  WIDGET_POSITION_DIR_RTL: 'Right To Left (default)',
  WIDGET_POSITION_DIR_LTR: 'Left To Right',
  WIDGET_OFFSET_MAX_ERROR: 'More than #value# px is not valid',
  WIDGET_LESS_THAN_0_PX_ERROR: 'Less than 0px is not valid',

  VALID_DOMAINS: 'Valid domains',
  VALID_DOMAINS_SUBTEXT: `
    The Richet widget only displays in the following domains and subdomains. In case of
    Being empty does not display in any domain.
    `,

  // Preview
  WIDGET_PREVIEW_TAB_LANDING: 'Landing Page',
  WIDGET_PREVIEW_TAB_CHAT: 'Chat Page',
};

export default WIDGET_CUSTOMIZATION;
